//  图层控制逻辑
import Store from '@/store'
import UEapi from '@/utils/UEapi/UEapi'
import layerMap from '@/utils/configs/layerMap'
import ObjectManager from '@/utils/control/ObjectManager'
import MapLayerContral from '@/utils/control/MapLayerContral'
import cameraList from '../configs/cameraList'
export default {
  modelSet: ['C03-004-04_SM_配线架', 'C03-004-04_SM_交换机', 'C03-004-04_SM_数据服务器_虚拟机', 'C03-004-04_SM_路由器', 'C03-004-04_SM_服务器', 'C03-004-04_SM_网络存储服务器', 'C03-004-04_SM_GPU服务器'],
  //Box_C03-004-04_机柜容量 后面一排机柜（挡住设备点击需隐藏）
  Rack: [
    // 'Box_C03-003-01_机柜容量',
    // 'Box_C03-003-02_机柜容量',
    // 'Box_C03-003-03_机柜容量',
    // 'Box_C03-003-04_机柜容量',
    // 'Box_C03-003-05_机柜容量',
    // 'Box_C03-003-06_机柜容量',
    // 'Box_C03-003-07_机柜容量',
    // 'Box_C03-003-08_机柜容量',
    // 'Box_C03-003-09_机柜容量',
    // 'Box_C03-003-10_机柜容量',
    'C03-003_SM_机柜组',
  ],
  coordZList: {
    默认场景: 2000,
    中国: 2000,
    北京: 2000,
    园区: 2,
    楼层: 10,
    房间: 10,
    机柜组机房: 10,
    电池组机房: 10,
    UPS设备机房: 10,
    机柜: 10,
  },
  timerList: {},

  // 重置所有图层状态为none
  resetSceneLayers() {
    let {
      sceneName,
    } = Store.state
    sceneName = sceneName == '默认服务' ? '中国' : sceneName
    for (const layerName in layerMap[sceneName]) {
      const layer = layerMap[sceneName][layerName]
      layer.layerConfig.status = 'none'
    }
    for (const layerName1 in layerMap.defaultLayers[sceneName]) {
      const layer1 = layerMap.defaultLayers[sceneName][layerName1]
      console.log(333, layer1);
      layer1.layerConfig.status = 'none'
    }
  },
  legendClick(legend) {
    let {
      sceneName
    } = Store.state
    sceneName = sceneName == '默认服务' ? '中国' : sceneName
    legend.layers.forEach(id => {
      let layer = layerMap[sceneName][id] || ''
      if (!layer) {
        return
      }
      switch (id) {
        // 非图层操作
        case "":
          break;
        default:
          if (legend.highlight && ['空间使用', '功耗使用', '承重使用'].includes(legend.showText)) {
            switch (legend.showText) {
              case '空间使用':
                window.appInstance.uniCall('setCamera', {
                  centerCoord: [116.2925688, 39.8281607],
                  coordType: 0,
                  coordTypeZ: 0,
                  coordZ: 8.13,
                  distance: 21.78,
                  heading: 330.67,
                  pitch: 39.88,
                  duration: 1,
                  fly: true,
                });
                break;
              case '功耗使用':
                window.appInstance.uniCall('setCamera', {
                  centerCoord: [116.2925688, 39.8281607],
                  coordType: 0,
                  coordTypeZ: 0,
                  coordZ: 8.13,
                  distance: 21.78,
                  heading: 31.67,
                  pitch: 32.22,
                  duration: 1,
                  fly: true,
                });
                break;
              case '承重使用':
                window.appInstance.uniCall('setCamera', {
                  centerCoord: [116.2925688, 39.8281607],
                  coordType: 0,
                  coordTypeZ: 0,
                  coordZ: 8.13,
                  distance: 14.45,
                  heading: 2,
                  pitch: 45.22,
                  duration: 1,
                  fly: true,
                });
                break;
            }
          } else if (!legend.highlight && ['空间使用', '功耗使用', '承重使用'].includes(legend.showText)) {
            window.appInstance.uniCall('setCamera', cameraList[Store.state.spaceLevel]);
          }
          if (layer.layerConfig.status != 'none') {
            this.setOverlayVisibility(layer, legend.highlight)
            if (legend.highlight) {
              this.updateLayer(layer)
            }
          } else {
            this.addLayer(layer)
          }
          break;
      }
    })
  },
  ShowHideLayer(arr) {
    let {
      sceneName,
      spaceLevel
    } = Store.state
    arr.forEach(item => {
      item.layers.forEach(id => {
        let layer = layerMap[sceneName][id] || ''
        if (!layer) {
          return
        }
        switch (id) {
          // 非图层操作
          case '':
            break;
          default:
            if (layer.layerConfig.status == 'hide') {
              this.setOverlayVisibility(layer, item.highlight)
              if (item.highlight) {
                this.updateLayer(layer)
              }
            } else {
              this.addLayer(layer)
            }
            break;
        }
      })
    })
  },
  // 添加cardName对应的图层
  addCardLayers(layers) {
    let {
      spaceLevel,
      sceneName
    } = Store.state
    let addLayers = [] //需要添加的
    let hideLayers = [] //需要隐藏的
    let showLayers = [] //需要显示的
    let updateLayers = [] //需要更新的
    // 园区关卡图层名称都是园区
    let level = sceneName == '园区' ? '园区' : spaceLevel
    for (const id in layerMap[level]) {
      const layer = layerMap[level][id];
      if (!layer) {
        console.log('没有这个图层', id);
      } else if (layers.includes(id) && layer.layerConfig.status == 'none') {
        // 查找需要添加的
        addLayers.push(layer)
      } else if (layers.includes(id) && layer.layerConfig.status == 'hide') {
        // 查找需要显示的
        showLayers.push(layer)
      } else if (!layers.includes(id) && layer.layerConfig.status == 'show') {
        // 查找需要隐藏的
        hideLayers.push(layer)
      } else if (layers.includes(id) && layer.layerConfig.status == 'show') {
        // 查找需要更新的
        updateLayers.push(layer)
      }
    }
    console.log(111, addLayers, hideLayers, showLayers, updateLayers)
    hideLayers.forEach(layer => {
      this.setOverlayVisibility(layer, false)
    })
    addLayers.forEach(layer => {
      this.addLayer(layer)
    })
    showLayers.forEach(layer => {
      this.setOverlayVisibility(layer, true)
      // 按需更新
      this.updateLayer(layer, true)
    })
    updateLayers.forEach(layer => {
      // 实际应该更新或控制显隐
      this.setOverlayVisibility(layer, true)
      this.updateLayer(layer, true)
    })
  },
  // 添加每个场景基础图层，如 城市名称 建筑物名称
  addDefaultLayers() {
    let {
      spaceLevel,
      sceneName
    } = Store.state
    let addLayers = [] //需要添加的
    for (const id in layerMap.defaultLayers[sceneName]) {
      const layer = layerMap.defaultLayers[sceneName][id];
      this.addLayer(layer)
      // if (layer.layerConfig.status == 'none') {
      //   this.addLayer(layer)
      //   layer.layerConfig.status = 'show'
      // } else if (layer.layerConfig.status == 'show') {
      //   this.setOverlayVisibility(layer, true)
      //   this.updateLayer(layer, true)
      // }
    }
  },
  async addLayer(layer) {
    console.log(1111, layer);
    const {
      spaceLevel,
      sceneName
    } = Store.state
    let dataFilter = spaceLevel || '中国'
    let {
      layerType,
      scatterType
    } = layer.layerConfig

    // 统一筛选数据
    if (!window.allData[scatterType]) {
      return
    }
    let rawData = window.allData[scatterType].RECORDS.filter(item => {
      return item.type == dataFilter
    })
    switch (layerType) {
      // 获取数据：根据项目中条件，自己定义获取数据方法 如专题，场景
      case 'landmarkLayer':
        if (layer.layerConfig.layerType1 == 'difLandmarkLayer') {
          var jsonData = this.transfromDifLandmarkLayerData(layer, rawData);
          layer.layerConfig.rawData = rawData
          layer.layerConfig.jsonData = jsonData
          layer.layerConfig.status = 'show'
          UEapi.LandmarkLayer.addLandmarkLayer(jsonData)
        } else {
          var jsonData = this.transfromLandmarkLayerData(layer, rawData);
          layer.layerConfig.rawData = rawData
          layer.layerConfig.jsonData = jsonData
          layer.layerConfig.status = 'show'
          if (spaceLevel == '北京') {
            setTimeout(() => {
              UEapi.LandmarkLayer.addLandmarkLayer(jsonData)
            }, 1000)
          } else {
            UEapi.LandmarkLayer.addLandmarkLayer(jsonData)
          }
        }
        break;
      case 'eventLayer':
        var jsonData = this.transformEventLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.EventLayer.addEventLayer(jsonData)
        break;
      case 'bubbleLayer':
        var jsonData = this.transformBubbleLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.Bubble.addBubbleLayer(jsonData)
        break
      case 'ODLineLayer':
        var jsonData = this.transformODLineLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.ODLineLayer.addODLineLayer(jsonData)
        break;
      case 'heatMapLayer':
        var jsonData = this.transformHeatMapLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.HeatMapLayer.addHeatMapLayer(jsonData)
        break;
      case '3DColumnLayer':
        var jsonData = this.transformGridColumnLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        if (jsonData.data.length > 80) {
          UEapi.Agg3DColumnLayer.add3DColumnLayerMaxLength(jsonData)
        } else {
          jsonData.pointDataId = ''
          UEapi.Agg3DColumnLayer.add3DColumnLayer(jsonData)
        }
        break;
      case 'path':
        var jsonData = this.transformgetPathData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.Path.addPath(jsonData)
        break;
      case 'roadSgHeatLayer':
        var jsonData = this.transformRoadSgHeatLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        if (jsonData.data.length > 800) {
          UEapi.RoadSgHeatLayer.addRoadSgHeatLayerCoordMaxLength(jsonData)
        } else {
          jsonData.lineDataId = ''
          UEapi.RoadSgHeatLayer.addRoadSgHeatLayerCoord(jsonData)
        }
        break;
      case 'panel':
        var jsonData = this.transfromLandmarkLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.LandmarkLayer.addLandmarkLayer(jsonData)
        console.log(MapLayerContral, 789);

        setTimeout(() => {
          MapLayerContral.addpanel(jsonData.id, jsonData.data)
        }, 1000)
        break;
      case 'trailLayer':
        var jsonData = this.transformTrailLayerData(layer, rawData)
        layer.layerConfig.status = 'show'
        UEapi.TrailLayer.addTrailLayer(jsonData, (res) => {
          var jsonData2 = this.updateTrailLayerData(rawData)
          layer.layerConfig.status = 'show'
          UEapi.TrailLayer.updateData(jsonData, jsonData2, this.coordZList[spaceLevel])
        })
        break;
      case 'typeAreaLayer':
        var jsonData = this.transformTypeAreaLayerData(layer, rawData);
        delete jsonData.layerConfig
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        window.appInstance.uniCall('addTypeAreaLayer', jsonData, res => {
          console.log('addTypeAreaLayer', jsonData, res);
        })
        break;
      case 'BoxLayer':
        this.setAllModelVisibility(false)
        var jsonData = this.transformBoxLayerData(layer, rawData)
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        break;
      case 'ModelLayer':
        var jsonData = this.transformModelLayerData(layer, rawData)
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        break;
      case 'JiGuiZuLayer':
        this.setJIGUIZUModelVisibility(false)
        var jsonData = this.transformBoxLayerData(layer, rawData)
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        break;
      default:
        break;

    }
  },
  async updateLayer(layer) {
    // 更新数据需要考虑是否是追加数据，此处使用 替换数据方式 如下
    // layer.layerConfig.rawData = rawData
    const {
      spaceLevel,
      sceneName
    } = Store.state
    let dataFilter = spaceLevel
    let {
      layerType,
      scatterType
    } = layer.layerConfig
    if (!scatterType) {
      return
    }
    // 统一筛选数据
    if (!window.allData[scatterType]) {
      return
    }
    let rawData = window.allData[scatterType].RECORDS.filter(item => {
      return item.type == dataFilter
    })

    switch (layerType) {
      // 获取数据：根据项目中条件，自己定义获取数据方法 如专题，场景
      case 'landmarkLayer':
        if (layer.layerConfig.layerType1 == 'difLandmarkLayer') {
          var jsonData = this.transfromDifLandmarkLayerData(layer, rawData);
          layer.layerConfig.rawData = rawData
          layer.layerConfig.jsonData = jsonData
          layer.layerConfig.status = 'show'
          UEapi.LandmarkLayer.updateLandmarkLayerCoord(jsonData)
          return
        }
        var jsonData = this.transfromLandmarkLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.LandmarkLayer.updateLandmarkLayerCoord(jsonData)
        break;
      case 'eventLayer':
        var jsonData = this.transformEventLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.EventLayer.updateEventLayerCoord(jsonData)
        break;
      case 'ODLineLayer':
        var jsonData = this.transformODLineLayerData(layer, rawData);
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.ODLineLayer.updateODLineLayerCoord(jsonData)
        break;
      case 'heatMapLayer':
        var jsonData = this.transformHeatMapLayerData(layer, rawData)
        layer.layerConfig.rawData = rawData
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        UEapi.HeatMapLayer.updateHeatMapLayerCoord(jsonData)
        break;
      case 'trailLayer':
        var jsonData = this.transformTrailLayerData(layer, rawData)
        layer.layerConfig.status = 'show'
        var jsonData2 = this.updateTrailLayerData(rawData)
        layer.layerConfig.status = 'show'
        UEapi.TrailLayer.updateData(jsonData, jsonData2, this.coordZList[spaceLevel])
        break;
      case 'BoxLayer':
        layer.layerConfig.status = 'show'
        break
      case 'ModelLayer':
        var jsonData = this.transformModelLayerData(layer, rawData)
        layer.layerConfig.jsonData = jsonData
        layer.layerConfig.status = 'show'
        break
      case 'JiGuiZuLayer':
        layer.layerConfig.status = 'show'
        break
      default:
        break;
    }
  },
  hideAllLayer() {
    const {
      sceneName,
    } = Store.state
    let scene = sceneName == '默认服务' ? '中国' : sceneName
    for (const key in layerMap[scene]) {
      const layer = layerMap[scene][key];
      if (layer.layerConfig.status == 'show') {
        layer.layerConfig.status == 'hide'
        this.setOverlayVisibility(layer, false)
      }
    }
  },
  hideSceneLayer() {
    const {
      sceneName,
    } = Store.state
    if (sceneName != '园区') {
      return
    }
    for (const key in layerMap[sceneName]) {
      const layer = layerMap[sceneName][key];
      if (layer.layerConfig.status == 'show') {
        layer.layerConfig.status == 'hide'
        this.setOverlayVisibility(layer, false)
      }
    }
  },
  setOverlayVisibility(layer, isVisible) {
    let type = ''
    if (layer.layerConfig.layerType == 'panel') {
      type = 'landmarkLayer'
    } else if (layer.layerConfig.layerType == 'model') {
      layer.layerConfig.status = isVisible ? 'show' : 'hide'
      window.appInstance.uniCall('setModelVisibility', {
        ids: layer.layerConfig.models,
        visible: isVisible
      }, res => { })
      return
    } else if (layer.layerConfig.layerType == 'trailLayer') {
      // if (isVisible) {
      //   this.addLayer(layer)
      // } else {
      //   this.removeTrailLayer(layer);
      // }
      // return
      if (!isVisible) {
        layer.layerConfig.status = 'none'
        UEapi.Common.removeOverlay({
          id: layer.id,
          overlayType: 'trailLayer',
        })
        UEapi.TrailLayer.clearTrailLayerTimers(layer.id);
        return
      }
      type = layer.layerConfig.layerType
    } else if (layer.layerConfig.layerType == 'BoxLayer') {
      let ids = layer.layerConfig.jsonData
      UEapi.Model.setModelVisibility({
        ids: ids,
        visible: isVisible
      })
      this.setAllModelVisibility(!isVisible);
      return
    } else if (layer.layerConfig.layerType == 'ModelLayer') {
      let ids = layer.layerConfig.jsonData
      ids.forEach(id => {
        UEapi.Model.setModelStyle({
          id: id,
          maskColor: 'none',
        })
        // 设置不可设置model标签
        UEapi.Model.setModelVisibility({
          ids: [id],
          visible: false,
        });
      })
      layer.layerConfig.status = 'none'
    } else if (layer.layerConfig.layerType == 'JiGuiZuLayer') {
      let ids = layer.layerConfig.jsonData
      UEapi.Model.setModelVisibility({
        ids: ids,
        visible: isVisible
      })
      // this.setJIGUIZUModelVisibility(!isVisible);
      layer.layerConfig.status = isVisible ? 'show' : 'hide'
      // layer.layerConfig.status = 'none'
      return
    } else {
      type = layer.layerConfig.layerType
    }
    window.appInstance.uniCall('setOverlayVisibility', {
      id: layer.id,
      overlayType: type,
      visible: isVisible,
    }, res => {
      console.log('setOverlayVisibility', layer.id, isVisible, res);
      layer.layerConfig.status = isVisible ? 'show' : 'hide'
      // if (layer.layerConfig.layerType == 'trailLayer' && isVisible) {
      //   console.log(111, isVisible)
      //   this.updateLayer(layer)
      // }
    });
  },
  removeOverlay(layer) {
    window.appInstance.uniCall('removeOverlay', {
      "id": layer.id,
      "overlayType": layer.layerType,
    }, res => {
      console.log(`删除图层-${layer.id}`, res);
    });
  },
  //设备模型唯一高亮
  modelOnlyHighlight(ID) {
    if (!ID) {
      this.modelSet.forEach(item => {
        UEapi.Model.setModelStyle({
          id: item,
          alpha: 1,
        });
      })
      return
    }
    if (ID !== 'C03-004-04_SM_数据服务器_虚拟机') {
      UEapi.Model.setModelArticulation(false);
    }

    ID && this.modelSet.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 1,
      });
    })

    let model = this.modelSet.filter(item => {
      return item !== ID
    })
    model.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 0.2,
      });
    })
  },
  ShowAlertLayer() {
    const {
      sceneName,
      spaceLevel,
      highLight
    } = Store.state
    let scene = sceneName == '默认服务' ? '中国' : sceneName
    for (const key in layerMap[scene]) {
      const layer = layerMap[scene][key];
      switch (spaceLevel) {
        case '中国':
          if (layer.id.indexOf('告警') !== -1) {
            this.setOverlayVisibility(layer, true)
          }
          break;
        case '北京':
          if (layer.id.indexOf('告警') !== -1) {
            this.setOverlayVisibility(layer, true)
          }
          break;
        case '园区':
          let arrYQ = [{
            layers: ['园区-告警_设备'],
            highlight: true
          },]
          window.layerConfig.ShowHideLayer(arrYQ)
          break;
        case '楼层':
          let arr = [{
            layers: ['园区-告警_设备'],
            highlight: true
          },
          {
            layers: ['园区-告警_能耗'],
            highlight: true
          },
          {
            layers: ['园区-告警_机柜告警实体状态'], //none
            highlight: true
          },
          {
            layers: ['园区-告警_机柜'],
            highlight: true
          }
          ]
          window.layerConfig.ShowHideLayer(arr)
          break;
        case '机柜组机房':
          let arrJGZ = [{
            layers: ['园区-告警_设备'], //hide
            highlight: true
          },
          {
            layers: ['园区-告警_能耗'], //none
            highlight: true
          },
          {
            layers: ['园区-告警_机柜'], //none
            highlight: true
          },
          {
            layers: ['园区-告警_机柜告警实体状态'], //none
            highlight: true
          },
          {
            layers: ['园区-告警_机器'], //show
            highlight: true
          },
          {
            layers: ['园区-告警_端口'],
            highlight: true
          }
          ]
          window.layerConfig.ShowHideLayer(arrJGZ)
          break;
        case 'UPS设备机房':
          let arrUPS = [{
            layers: ['园区-告警_设备'],
            highlight: true
          },

          {
            layers: ['园区-告警_机柜'],
            highlight: true
          },
          {
            layers: ['园区-告警_机器'],
            highlight: true
          },
          {
            layers: ['园区-告警_能耗'],
            highlight: true
          },
          {
            layers: ['园区-告警_端口'],
            highlight: true
          }
          ]
          window.layerConfig.ShowHideLayer(arrUPS)
          break;
        case '电池组机房':
          let arrdcz = [{
            layers: ['园区-告警_设备'],
            highlight: true
          },
          {
            layers: ['园区-告警_能耗'],
            highlight: true
          }
          ]
          window.layerConfig.ShowHideLayer(arrdcz)
          break;
        default:
          break;
      }
    }
  },
  //机柜组模型唯一高亮
  equipmentCabinetOnlyHighlight(ID) {
    const JGgroup = ObjectManager.BoxZ.map(item => item.id)
    let isExist = JGgroup.find(item => {
      return item == ID
    })
    if (isExist) {
      JGgroup.forEach(item => {
        UEapi.Model.setModelStyle({
          id: item,
          alpha: 1,
        });
      })
      let NeedHideJGgroup = JGgroup.filter(item => {
        return item !== ID
      })
      // cameraList[ID] && UEapi.Camera.setCamera(cameraList[ID])
      UEapi.Camera.focusModel({
        id: ID,
        modelType: 'model',
        distance: 5
      })
      NeedHideJGgroup && NeedHideJGgroup.forEach(item => {
        UEapi.Model.setModelStyle({
          id: item,
          alpha: 0.2,
        });
      })
    }
  },
  //机柜模型唯一高亮
  rackOnlyHighlight(ID) {
    let RACK = {
      'A01-004-04_SM_机柜组': 'A01-004_SM_机柜组',
      'C03-004-04_SM_设备机柜': 'C03-004_SM_机柜组',
      'F06-004-07_SM_设备机柜': 'F06-004_SM_机柜组',
    }
    UEapi.Model.setModelStyle({
      id: RACK[ID],
      alpha: 0.1,
    });
  },
  //恢复模型初始状态
  recoverDefaultState() {
    const lineData = [...ObjectManager.linkList, ...ObjectManager.linkList_2];
    let equipmentCabinet = [{
      name: "Box_F06-004-04_机柜容量",
      id: "F06-004-07_SM_设备机柜"
    },
    {
      name: "Box_C03-004-04_机柜容量",
      id: "C03-004-04_SM_设备机柜"
    },
    {
      name: "Box_A01-004-04_机柜容量",
      id: "A01-004-04_SM_机柜组"
    },
    ]
    const BoxZ = ObjectManager.BoxZ.map(item => item.id)
    UEapi.Model.setModelVisibility({
      ids: lineData,
      visible: false,
    });
    UEapi.Model.setModelVisibility({
      ids: ['C03-004_SM_机柜组', ...this.Rack],
      visible: true,
    });
    BoxZ.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 1,
      });
    })
    equipmentCabinet.forEach(item => {
      UEapi.Model.playAnimation({
        id: item.id,
        name: '机柜_前_关',
        state: 'begin'
      })
      UEapi.Model.playAnimation({
        id: item.id,
        name: '机柜_后_关',
        state: 'begin'
      })
    })
    this.modelSet.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 1,
      });
    })
  },
  //聚焦机柜
  focusJiGui(id, isPlayAnimation = true) {
    const Box = ObjectManager.Box.map(item => item.id)
    const BoxZ = ObjectManager.BoxZ.map(item => item.id)
    const lines = [...ObjectManager.linkList, ...ObjectManager.linkList_2];
    Box.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 0,
      });
    })
    BoxZ.forEach(item => {
      UEapi.Model.setModelStyle({
        id: item,
        alpha: 0.1,
      });
    })
    UEapi.Model.setModelVisibility({
      ids: lines,
      visible: false,
    });
    if (id == 'A01-004-04_SM_机柜组') {
      UEapi.Model.setModelStyle({
        id: 'A01-004-04_SM_机柜组',
        alpha: 1,
      });
    }
    if (id == 'C03-004-04_SM_设备机柜') {
      UEapi.Model.setModelVisibility({
        ids: ['Box_C03-004-04_机柜容量', ...this.Rack],
        visible: false,
      });
    }
    if (isPlayAnimation) {
      //机柜_前_开 机柜_后_开 机柜_前_关 机柜_后_关
      id && UEapi.Model.playAnimation({
        id: id,
        name: '机柜_前_开',
        state: 'begin'
      })
      id && UEapi.Model.playAnimation({
        id: id,
        name: '机柜_后_开',
        state: 'begin'
      })
    }

  },

  setAllModelVisibility(isVisible) {
    const idZ = ObjectManager.BoxZ.map(item => item.id)
    const id = ObjectManager.Box.map(item => item.id)
    const lines = [...ObjectManager.linkList, ...ObjectManager.linkList_2];
    UEapi.Model.setModelVisibility({
      ids: [
        // ...id,
        ...idZ,
        // ...lines,
        'F06-004-07_SM_设备机柜',
        'C03-004-04_SM_设备机柜',
        'A01-004-04_SM_机柜组',

        'A01-01_SM_防尘顶板',
        'A02-01_SM_防尘顶板',
        'C03-01_SM_防尘顶板',
        'D04-01_SM_防尘顶板',
        'A04-03_SM_防尘顶板',
        'E05-01_SM_防尘顶板',
        'E05-03_SM_防尘顶板',
        'F06-01_SM_防尘顶板',
        'F06-03_SM_防尘顶板',

        'A01-02_SM_放尘玻璃门',
        'A02-02_SM_放尘玻璃门',
        'C03-02_SM_放尘玻璃门',
        'D04-02_SM_放尘玻璃门',
        'A04-04_SM_放尘玻璃门',
        'E05-02_SM_放尘玻璃门',
        'E05-04_SM_放尘玻璃门',
        'F06-02_SM_放尘玻璃门',
        'F06-04_SM_放尘玻璃门',
        'C03-002_SM_放尘玻璃门',

        'C03-004-04_SM_配线架',
        'C03-004-04_SM_交换机',
        'C03-004-04_SM_数据服务器_虚拟机',
        'C03-004-04_SM_路由器',
        'C03-004-04_SM_服务器',
        'C03-004-04_SM_网络存储服务器',
        'C03-004-04_SM_GPU服务器',
        'A01-004-04_SM_配线架',
        'A01-004-04_SM_服务器',
        'F06-004-04_SM_配线架',
        'F06-004-04_SM_大型服务器',

      ],
      visible: isVisible,
    });
  },
  setJIGUIZUModelVisibility(isVisible) {
    UEapi.Model.setModelVisibility({
      ids: [
        'C03-004-02_空间使用',
        'C03-004-03_空间使用',
        'C03-004-04_空间使用',
        'C03-004-05_空间使用',
        'C03-004-06_空间使用',
        'C03-004-07_空间使用',
        'C03-004-08_空间使用',
        'C03-004-09_空间使用',
        'C03-004-10_空间使用',
      ],
      visible: isVisible,
    });
  },
  //转换气泡图数据
  transformBubbleLayerData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'idObj',
      name: 'layerName',
      coordType: 0,
      coordTypeZ: 0,
      fillArea: "none",
      speed: 50,
      radiusMax: 1000,
      radiusMin: 50,
      valueMax: 1000,
      valueMin: 0,
      visible: true,
      legends: [],
      data: [],
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    jsonData.data = rawData.map(item => {
      return {
        id: item.id,
        value: parseInt(Math.random() * 10) + 1,
        coord: [item.lon, item.lat],
        coordZ: this.coordZList[spaceLevel] || 1,
        type: "default"
      }
    })
    return jsonData
  },
  // 转换LandmarkLayer数据
  transfromLandmarkLayerData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'idObj',
      name: 'layerName',
      coordType: 0,
      coordTypeZ: 0,
      autoScale: false,
      visible: true,
      legends: [],
      data: [],
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    jsonData.data = rawData.map(item => {
      return {
        id: item.id,
        label: layer.layerConfig.showLabel ? item.value : '',
        coord: [item.lon, item.lat],
        coordZ: this.coordZList[spaceLevel] || 1,
        type: item.id == 'shujuzhongxin1' ? '北京数据中心' : "default"
      }
    })
    return jsonData
  },
  // 转换不同图例的图层
  transfromDifLandmarkLayerData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'idObj',
      name: 'layerName',
      coordType: 0,
      coordTypeZ: 0,
      autoScale: false,
      visible: true,
      legends: [],
      data: [],
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    jsonData.legends = rawData.map(item => {
      return {
        name: item.name,
        color: '#ffff',
        iconName: item.name || 'custom-' + item.name,
      }
    })
    jsonData.data = rawData.map(item => {
      return {
        id: item.id,
        label: "",
        coord: [item.lon, item.lat],
        coordZ: layer.layerConfig.coordZ || 1,
        type: item.name
      }
    })
    return jsonData
  },
  // 转换事件图数据
  transformEventLayerData(layer, rawData) {
    const { spaceLevel } = Store.state
    let defaultOption = {
      id: "idObj",
      name: "layerName",
      coordType: 0,
      coordTypeZ: 0,
      visible: true,
      legends: [],
      data: []
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    jsonData.data = rawData.map(item => {
      return {
        id: item.id,
        coord: [item.lon, item.lat],
        coordZ: this.coordZList[spaceLevel] || 1,
        message: "",
        type: item.category ? (item.category ? "default" : item.category) : "default"
      }
    })
    return jsonData
  },
  // 转换类型区域图数据
  transformTypeAreaLayerData(layer, rawData) {
    let defaultOption = {
      id: 'typeAreaId',
      name: "layerName",
      coordType: 0,
      coordTypeZ: 0,
      coordZ: 10,
      alpha: 0.5,
      visible: true,
      lineDataId: "",
      areas: [
        // {
        //   name: "areaName01",
        //   points: [
        //     { coord: [103.976547, 1.397829] },
        //   ]
        // },
      ],
      legends: [
        // {
        //   name: "legendName1",
        //   type: "wave",
        //   color: "#ff0000",
        //   areaHeight: 10,
        //   fillArea: "none",
        //   fillPosition: "top"
        // },
      ],
      data: [
        // {
        //   areaName: "areaName01",
        //   legendName: "legendName3"
        // },
      ]
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    let areas = []
    let legends = []
    let data = []
    rawData.forEach(item => {
      areas.push({
        name: item.id,
        points: item.points.map(point => {
          return {
            coord: point
          }
        })
      })
      // 此处图层样式一样，使用一个legelds，可以循环配置
      legends.push(layer.legends[0])
      data.push({
        areaName: item.id,
        legendName: 'legendName1'
      })
    })
    jsonData.areas = areas
    jsonData.legends = legends
    jsonData.data = data
    return jsonData
  },
  // 热图
  transformHeatMapLayerData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'heat',
      name: '热力图',
      coordType: 0,
      coordTypeZ: 0,
      coordZ: this.coordZList[spaceLevel],
      type: 'default',
      alpha: 0.6,
      colorMax: '#FF6000',
      colorMin: '#009acf',
      valueMax: 200,
      valueMin: 10,
      radius: 4,
      visible: true,
      pointDataId: '',
      data: []
    };
    let jsonData = Object.assign({}, defaultOption, layer)
    let data = []
    rawData.forEach(item => {
      data.push({
        coord: [item.lon || item.jd, item.lat || item.wd],
        value: item.count - 0 || item.value - 0,
      })
    })
    jsonData.data = data
    return jsonData
  },
  // 柱图
  transformGridColumnLayerData(layer, rawData) {
    let defaultOption = {
      id: 'bar',
      name: '三维柱状图',
      coordType: 0,
      coordTypeZ: 0,
      coordZ: 64,
      columnType: 'cube',
      columnMinHeight: 10,
      columnMaxHeight: 300,
      columnAlpha: 1,
      columnPaint: 'solid',
      columnGap: 0,
      columnWidth: 30,
      colorMax: '#FF2626',
      colorMin: '#FFFF00',
      valueMax: 250,
      valueMin: 10,
      labelColor: '#ffffff',
      labelBackgroundColor: '#333333',
      visible: true,
      pointDataId: '',
      legends: [],
      data: []
    };
    let jsonData = Object.assign({}, defaultOption, layer)
    let data = []
    rawData.forEach(item => {
      data.push({
        id: item.id || item.gridid,
        coord: [item.jd || item.lon, item.wd || item.lat],
        value: item.count || item.value,
        // label: layer.layerConfig.labelShow ? item.text || item.value : ''
      })
    })
    jsonData.data = data
    jsonData.legends = layer.legends
    return jsonData
  },
  // 路径
  transformgetPathData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'path',
      name: '路径',
      coordType: 0,
      coordTypeZ: 0,
      type: 'Segment06',
      texture: "",
      textureSpeed: 0,
      color: '#ff0000',
      colorPass: '#0000FF',
      width: 40,
      tag: 'custominfo', // 用户自定标签，用户保存用户的扩展数据
      autoScale: false,
      lineDataId: '', // 对应本服务器上线数据对象，如果找到lineDataId，则下方的points不起作用。注意：此属性端渲染未生效
      points: [],
    };
    let jsonData = Object.assign({}, defaultOption, layer)
    let pointsData = []
    rawData.forEach((item, index) => {
      const {
        points,
        id
      } = item;
      points.map(p => {
        pointsData.push({
          coord: p,
          coordZ: this.coordZList[spaceLevel] || 20
        });
      });
    });
    jsonData.points = pointsData
    return jsonData
  },
  //转换关系图数据
  transformODLineLayerData(layer, rawData) {
    let defaultOption = {
      id: 'odline',
      name: '关系图',
      coordType: 0,
      coordTypeZ: 0,
      isShowBubble: true,
      bubbleRadiusMax: 80,
      bubbleRadiusMin: 50,
      bubbleSpeed: 20,
      lineWidthMax: 50,
      lineWidthMin: 20,
      lineSpeed: 2,
      curvature: 0.8,
      valueMax: 100,
      valueMin: 10,
      visible: true,
      legends: [],
      data: []
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    let data = []
    rawData.forEach(item => {
      data.push({
        id: item.id,
        startCoord: item.startCoord,
        startCoordZ: layer.layerConfig.startCoordZ || 0,
        targetCoord: item.targetCoord,
        targetCoordZ: layer.layerConfig.targetCoordZ || 0,
        value: item.value || parseInt(Math.random() * 10) + 1,
        type: 'default'
      })
      // 此处图层样式一样，使用一个legelds，可以循环配置

    })
    jsonData.legends = layer.legends
    jsonData.data = data
    return jsonData
  },
  // 路径段热力图
  transformRoadSgHeatLayerData(layer, rawData) {
    let defaultOption = {
      id: 'idObj',
      name: 'layerName',
      coordType: 0,
      coordTypeZ: 0,
      alpha: 1,
      width: 30,
      colorMax: '#FF0000',
      colorMin: '#00FF00',
      valueMax: 1000,
      valueMin: 0,
      lineDataId: '',
      visible: true,
      segments: [],
      data: []
    }
    let jsonData = Object.assign({}, defaultOption, layer)
    let data = [];
    let segments = [];
    if (rawData.length > 800) {
      rawData.forEach((item, index) => {
        let dateItem = {
          id: layer.id + index,
          name: layer.id + index,
          value: Math.floor(Math.random() * 500),
          points: item.points.map(point => {
            return {
              coord: point,
              coordZ: this.coordZList[spaceLevel] || 64
            };
          })
        };
        data.push(dateItem);
      });
      jsonData.data = data
      jsonData.attribute = [layer.lineDataId];
      return jsonData
    } else {
      rawData.forEach(item => {
        let segment = {
          name: item.id,
          points: item.points.map(point => {
            return {
              coord: point,
              coordZ: this.coordZList[spaceLevel] || 64,
            }
          })
        };
        let dateItem = {
          name: item.id,
          value: Math.floor(Math.random() * 500),
        }
        segments.push(segment);
        data.push(dateItem);
      })
      jsonData.segments = segments
      jsonData.data = data
      return jsonData
    }
  },
  transformBoxLayerData(layer, rawData) {
    let jsonData = []
    const {
      scatterType,
      legends
    } = layer.layerConfig
    if (scatterType == '承重使用') {
      rawData.forEach((item) => {
        const {
          id,
          x,
          y,
          z,
          weight
        } = item
        const ratio = weight / 500
        let category = 'defalut';
        if (ratio >= 0.8) {
          category = '80';
        } else if (ratio >= 0.6) {
          category = '60';
        } else if (ratio >= 0.4) {
          category = '40';
        } else {
          category = '20';
        }
        const legend = legends[category]
        UEapi.Model.addModel({
          id,
          modelType: 'Box_A01-001-05_机柜容量', // 模型类型
          coordType: 1,
          coordTypeZ: 1,
          coord: [x, y],
          coordZ: z,
          visible: false,
          alpha: 1,
          scale: [1, ratio, 1]
        });

        if (legend) {
          UEapi.Model.setModelStyle({
            id: id,
            maskType: 'color',
            maskAlpha: 1,
            maskColor: legend.color,
          });
        }
        jsonData.push(id);
      })
    } else if (scatterType == '空间使用') {
      rawData.forEach((item) => {
        const {
          id,
          x,
          y,
          z,
          category,
          ZScale
        } = item
        UEapi.Model.addModel({
          id: id,
          modelType: 'Box_A01-001-05_机柜容量', // 模型类型
          coordType: 1,
          coordTypeZ: 1,
          coord: [x, y],
          coordZ: z,
          visible: false,
          alpha: 1,
          scale: [1, ZScale, 1],
        });
        const legend = legends[category]
        if (legend) {
          UEapi.Model.setModelStyle({
            id: id,
            maskType: 'color',
            maskAlpha: layer.layerConfig.alpha || 0.5,
            maskColor: legend.color,
          });
        }
        jsonData.push(id);
      })
    } else if (scatterType == '功耗使用') {
      rawData.forEach((item) => {
        const {
          id,
          x,
          y,
          z,
          category
        } = item

        UEapi.Model.addModel({
          id,
          modelType: 'Box_A01-001-05_机柜容量', // 模型类型
          coordType: 1,
          coordTypeZ: 1,
          coord: [x, y],
          coordZ: z,
          visible: false,
          alpha: 1,
          scale: 1
        });
        const legend = legends[category]
        if (legend) {
          UEapi.Model.setModelStyle({
            id: id,
            maskType: 'color',
            maskAlpha: 1,
            maskColor: legend.color,
          });
        }

        jsonData.push(id);
      })
    } else if (scatterType == '空间搜索机柜组') {
      rawData.forEach((item) => {
        const {
          id,
          x,
          y,
          z,
          category,
          ZScale
        } = item
        UEapi.Model.addModel({
          id: id,
          modelType: 'Box_A01-001-05_机柜容量', // 模型类型
          coordType: 1,
          coordTypeZ: 1,
          coord: [x, y],
          coordZ: z,
          visible: true,
          alpha: 1,
          scale: [1, 1, ZScale],
        });
        const legend = legends[category]
        if (legend) {
          UEapi.Model.setModelStyle({
            id: id,
            maskType: 'color',
            maskAlpha: 1,
            maskColor: legend.color,
          });
        }
        jsonData.push(id);
      })
    }
    return jsonData
  },
  // 转换模型
  transformModelLayerData(layer, rawData) {
    let jsonData = []
    rawData.forEach((item) => {
      const {
        id,
        color
      } = item
      // 设置可设置颜色
      UEapi.Model.setModelVisibility({
        ids: [id],
        visible: true
      })
      UEapi.Model.setModelStyle({
        id: id,
        maskType: 'color',
        maskAlpha: 0.8,
        maskColor: color || layer.color,
      })
      jsonData.push(id);
    })
    return jsonData
  },
  // 轨迹图
  //获取轨迹图数据
  transformTrailLayerData(layer, rawData) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'idObj',
      name: 'layerName',
      coordType: 0,
      coordTypeZ: 0,
      trackStyle: 'style001',
      trackDuration: 30,
      trackWidth: 10,
      objLife: 10,
      visible: true,
      duration: 1,
      data: [],
    }
    let trailList = {};
    rawData.forEach((item) => {
      if (trailList[item.name]) {
        trailList[item.name].push({
          lon: item.lon,
          lat: item.lat,
          id: item.name,
          name: item.name,
          time: item.time,
        });
      } else {
        trailList[item.name] = [{
          lon: item.lon,
          lat: item.lat,
          id: item.name,
          name: item.name,
          time: item.time,
        }];
      }
    });
    layer.layerConfig.jsonData = trailList
    let jsonData = Object.assign({}, defaultOption, layer)
    let arr = [];
    for (let key in trailList) {
      // arr.push(trailList[key][layer.layerConfig.index % trailList[key].length])
      arr.push(trailList[key][0])
    };
    jsonData.data = arr.map(item => {
      return {
        id: item.id,
        label: "",
        coord: [item.lon, item.lat],
        coordZ: this.coordZList[spaceLevel] || 1,
        type: "default"
      }
    })
    return jsonData
  },
  updateTrailLayerData(rawData) {
    let trailList = {}
    rawData.forEach((item) => {
      if (trailList[item.name]) {
        trailList[item.name].push({
          lon: item.lon - 0,
          lat: item.lat - 0,
          id: item.name,
          name: item.name,
          time: item.time,
        });
      } else {
        trailList[item.name] = [{
          lon: item.lon - 0,
          lat: item.lat - 0,
          id: item.name,
          name: item.name,
          time: item.time,
        }];
      }
    });
    let arr = [];
    for (let key in trailList) {
      arr.push({
        data: trailList[key]
      })
    };
    return arr
  },
  // 获取轨迹图更新数据
  getCurrentTrailLayerData(layer, index) {
    const {
      spaceLevel
    } = Store.state
    let defaultOption = {
      id: 'trail',
      name: '轨迹图',
      coordType: 0,
      coordTypeZ: 0,
      isAppend: true,
      duration: 1,
      data: [],
    }
    let trailList = layer.layerConfig.jsonData;
    let jsonData = {}
    for (const key in defaultOption) {
      jsonData[key] = layer[key] || defaultOption[key]
    }
    let arr = [];
    for (let key in trailList) {
      // arr.push(trailList[key][index % trailList[key].length])
      arr.push(trailList[key][0])
    };
    jsonData.data = arr.map(item => {
      return {
        id: item.id,
        label: "",
        coord: [item.lon, item.lat],
        coordZ: this.coordZList[spaceLevel] || 1,
        type: "default"
      }
    })
    return jsonData
  },
  // 删除轨迹图
  removeTrailLayer(layer) {
    layer.layerConfig.index = 0;
    layer.layerConfig.status = 'hide';
    this.timerList[layer.id] && clearInterval(this.timerList[layer.id])
    UEapi.Common.removeOverlay({
      "id": layer.id,
      "overlayType": 'trailLayer'
    })
    delete this.timerList[layer.id]
  },
  clearTrailLayer() {
    let {
      sceneName
    } = Store.state
    for (const legend in this.timerList) {
      let layer = layerMap[sceneName][legend]
      this.removeTrailLayer(layer)
    }
  },
  addpanel(id, data) {
    data.forEach((p, index) => {
      let ele = null
      ele = panelControl.create(p.id, this.PanelSetting[id].com, p, 1)
      appInstance.uniCall(
        'addOverlayTip', {
        id: p.id,
        url: '',
        size: [ele.clientWidth, ele.clientHeight],
        offset: this.PanelSetting[id].offset || [-1000, -1000],
        overlayType: 'landmarkLayer',
        isShowClose: false,
        divId: ele.id,
      },
        (tip) => {
          this.panelArr.push({
            id: id,
            value: p.id,
          })
          console.log('添加标牌', ele, tip, 'maplayer')
        }
      )
    })
  }

}






